module.exports = __webpack_public_path__ + "img/jasd.81c0db48.png";